module.exports = __webpack_public_path__ + "img/left-arrow.66766199.png";